export const STAGES = {
  LOCAL: 'LOCAL',
  DEV: 'dev',
  BETA: 'beta',
  PROD: 'prod'
} as const;

type StageType = (typeof STAGES)[keyof typeof STAGES];

interface AppConfig {
  CORE: string;
}

const API_CONFIGS: Record<string, AppConfig> = {
  default: { CORE: 'https://raptor.ws-voices.com/v1/' },
  develop: { CORE: 'https://raptor.ws-voices.com/v1/' },
  beta: { CORE: 'https://raptor.ws-voices.com/v1/' },
  prod: { CORE: 'https://raptor.ws-voices.com/v1/' }
};

const ENV_MAPPING: Record<string, StageType> = {
  develop: STAGES.DEV,
  beta: STAGES.BETA,
  prod: STAGES.PROD
};

const currentEnv = process.env.REACT_APP_STAGE || 'local';

/** Garantiza la diagonal final: todos los servicios concatenan `${CORE}recurso`. */
const withTrailingSlash = (url: string): string => (url.endsWith('/') ? url : `${url}/`);

/**
 * La base de la API sale de `REACT_APP_API_CORE` (`.env`, `.env.local` o la
 * variable de entorno del build). Si no está definida se cae al mapa por stage
 * de arriba, que es lo que había cableado antes.
 */
const envCore = (process.env.REACT_APP_API_CORE || '').trim();
const stageCore = (API_CONFIGS[currentEnv] || API_CONFIGS.default).CORE;

export const API_ENDPOINT: AppConfig = {
  CORE: withTrailingSlash(envCore || stageCore)
};
export const ENV_NAME: StageType = ENV_MAPPING[currentEnv] || STAGES.LOCAL;

export const STORAGE_PREFIX = 'raptor-';

export const STORAGE = {
  TOKEN: `${STORAGE_PREFIX}token`,
  SESSION: `${STORAGE_PREFIX}session`,
  SELECTED_ACCOUNT: `${STORAGE_PREFIX}selected_account`,
  ACCOUNTS: `${STORAGE_PREFIX}accounts`,
  ROLE_DATA: `${STORAGE_PREFIX}role_data`,
  TWO_FA_TEMP_SESSION: `${STORAGE_PREFIX}two_fa_temp_session`
} as const;

export const PROFILES = {
  SUPER_ADMIN: 'superadmin',
  ADMIN: 'admin',
  SUPERVISOR: 'supervisor',
  OPERADOR: 'operador'
} as const;

export type UserProfile = (typeof PROFILES)[keyof typeof PROFILES];
